module.exports = __webpack_public_path__ + "static/media/ball_4_4.f40d2de8.mp3";